import { useNavigate, useRouter, useSearch } from '@tanstack/react-router';
import { ArrowLeft, ChevronRight, Send } from 'lucide-react';

import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/shared/components/shadcn/breadcrumb';
import { Button } from '@/shared/components/shadcn/button';
import { Skeleton } from '@/shared/components/shadcn/skeleton';
import { Stage } from '@/shared/components/stage/stage';

export function ReferencedPostsHeader(props: {
  queryName?: string;
  claimTitle?: string;
  isLoading: boolean;
  onShareClick: () => void;
}) {
  const { queryName, claimTitle, isLoading, onShareClick } = props;
  const navigate = useNavigate();
  const router = useRouter();
  const { q } = useSearch({ strict: false }) as { q: string };

  const handleBack = () => {
    if (router.history.length > 2) {
      router.history.back();
    } else {
      navigate({
        from: '/workspace/$workspaceId/insight/referenced-posts',
        to: '/workspace/$workspaceId/insight',
        search: {
          q,
        },
      });
    }
  };

  return (
    <div className="bg-background flex flex-col px-6 pb-2">
      <div className="flex items-center justify-between gap-2">
        <Button className="my-8 w-fit" variant="outline" size="default" onClick={handleBack}>
          <ArrowLeft className="size-4" />
          Back
        </Button>
        <Button
          className="my-8 w-fit"
          variant="default"
          size="default"
          onClick={onShareClick}
          disabled={isLoading}
        >
          <Send className="size-4" />
          Share
        </Button>
      </div>
      <Stage>
        <Stage.Scene status={isLoading}>
          <Skeleton className="h-4 w-60 rounded-md" />
        </Stage.Scene>
        <Stage.Scene default>
          <Breadcrumb>
            <BreadcrumbList className="flex-wrap">
              <span className="contents">
                <BreadcrumbItem>
                  <span className="text-muted-foreground">{queryName}</span>
                </BreadcrumbItem>
                <BreadcrumbSeparator>
                  <ChevronRight className="size-4" />
                </BreadcrumbSeparator>
                <BreadcrumbItem>
                  <span className="text-muted-foreground">{claimTitle}</span>
                </BreadcrumbItem>
              </span>
            </BreadcrumbList>
          </Breadcrumb>
        </Stage.Scene>
      </Stage>
    </div>
  );
}
